import {
  breakpointSizes,
  getBreakpointOnly,
  styleConstants,
} from '@paywithextend/components'
import React from 'react'
import { css } from 'styled-components'

interface InsetBoxProps {
  className?: string
  onClick?: () => void
}

const InsetBox: React.FC<React.PropsWithChildren<InsetBoxProps>> = (
  props,
): React.ReactElement => {
  return (
    <div
      className={props.className}
      css={css`
        background-color: ${styleConstants.colors.gray_lightest};
        padding: ${styleConstants.heights.cardPadding}
          ${styleConstants.widths.cardPaddingXSMUp};
        border-radius: ${styleConstants.borderRadius.box};
        border: 1px solid ${styleConstants.colors.gray_light};

        ${getBreakpointOnly(breakpointSizes.XXSM)(css`
          padding: ${Number(
              styleConstants.heights.cardPadding.replace('px', ''),
            ) / 2}px
            ${styleConstants.widths.cardPaddingXXSMOnly};
        `)}
      `}
      onClick={props.onClick}
      onKeyPress={props.onClick}
      role="button"
      tabIndex={0}
    >
      {props.children}
    </div>
  )
}

export default InsetBox
